'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _sliceInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/slice');
var _Array$from = require('@babel/runtime-corejs3/core-js-stable/array/from');
var _Symbol = require('@babel/runtime-corejs3/core-js-stable/symbol');
var _getIteratorMethod = require('@babel/runtime-corejs3/core-js/get-iterator-method');
var _Array$isArray = require('@babel/runtime-corejs3/core-js-stable/array/is-array');
var _classCallCheck = require('@babel/runtime-corejs3/helpers/classCallCheck');
var _createClass = require('@babel/runtime-corejs3/helpers/createClass');
var loadingMapping_model = require('./loading-mapping.model.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _sliceInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_sliceInstanceProperty);
var _Array$from__default = /*#__PURE__*/_interopDefaultLegacy(_Array$from);
var _Symbol__default = /*#__PURE__*/_interopDefaultLegacy(_Symbol);
var _getIteratorMethod__default = /*#__PURE__*/_interopDefaultLegacy(_getIteratorMethod);
var _Array$isArray__default = /*#__PURE__*/_interopDefaultLegacy(_Array$isArray);
var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);
var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof _Symbol__default["default"] && _getIteratorMethod__default["default"](r) || r["@@iterator"]; if (!t) { if (_Array$isArray__default["default"](r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { var _context; if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = _sliceInstanceProperty__default["default"](_context = {}.toString.call(r)).call(_context, 8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? _Array$from__default["default"](r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/**
 * Common business logic for load to vertex and load to edge.
 *
 * @export
 * @class LoadToEntityLogic
 */
var LoadToEntityLogic = /*#__PURE__*/function () {
  function LoadToEntityLogic() {
    _classCallCheck__default["default"](this, LoadToEntityLogic);
  }
  return _createClass__default["default"](LoadToEntityLogic, null, [{
    key: "validationCheck",
    value:
    /**
     * Check if the GSQL load to vertex | edge json is valid json, i.e., not containing
     * unsupported features.
     *
     * @static
     * @param {(GSQLLoadToVertexJson | GSQLLoadToEdgeJson)} loadToEntityJson
     * @returns {{
     *     success: boolean,
     *     message?: string
     *   }}
     * @memberof LoadToEntityLogic
     */
    function validationCheck(loadToEntityJson) {
      // 1. DataSource is not Online
      if (loadToEntityJson.DataSource.Type !== 'FileVar') {
        return {
          success: false,
          message: "Data source type \"".concat(loadToEntityJson.DataSource.Type, "\" ") + 'is not supported in Graph Studio.'
        };
      }

      // 3. Options is not empty
      if ('Options' in loadToEntityJson && loadToEntityJson.Options !== '') {
        return {
          success: false,
          message: '"Options" is not supported in Graph Studio.'
        };
      }

      // 4. Recursively check each mapping item is supported types
      var _iterator = _createForOfIteratorHelper(loadToEntityJson.Mappings),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var oneColumnMapping = _step.value;
          var validationCheckOneColumnMapping = loadingMapping_model.LoadingMappingLogic.validationCheck(oneColumnMapping);
          if (!validationCheckOneColumnMapping.success) {
            return validationCheckOneColumnMapping;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return {
        success: true
      };
    }

    /**
     * Semantic check if the load to vertex | edge statement has semantic errors.
     *
     * @static
     * @param {(LoadToVertexData | LoadToEdgeData)} loadToEntity
     * @param {string[]} header
     * @returns {{
     *     success: boolean,
     *     message: string
     *   }}
     * @memberof LoadToEntityLogic
     */
  }, {
    key: "semanticCheck",
    value: function semanticCheck(loadToEntity, header) {
      // 1. Token function number and middle style number don't match
      if (loadToEntity.mappingWidgets.length !== loadToEntity.style.middlePositions.length) {
        return {
          success: false,
          message: 'Token function number and token function style number do not match.'
        };
      }

      // 2. Loading mapping refer to a data source column out of boundary
      var _iterator2 = _createForOfIteratorHelper(loadToEntity.mappings),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var mapping = _step2.value;
          if (mapping.sourceType === loadingMapping_model.SourceType.DataSourceColumn && mapping.index >= header.length) {
            return {
              success: false,
              message: 'Data mapped to a column outside data source columns.'
            };
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      var _iterator3 = _createForOfIteratorHelper(loadToEntity.mappingWidgets),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var widget = _step3.value;
          var _iterator4 = _createForOfIteratorHelper(widget.params),
            _step4;
          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var _mapping = _step4.value;
              if (_mapping.sourceType === loadingMapping_model.SourceType.DataSourceColumn && _mapping.index >= header.length) {
                return {
                  success: false,
                  message: 'Token function parameter mapped to a column outside data source columns.'
                };
              }
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }
        }

        // pass semantic check
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      return {
        success: true,
        message: ''
      };
    }
  }]);
}();

exports.LoadToEntityLogic = LoadToEntityLogic;
